import dayjs from "dayjs";
import ToolTip from "components/design/toolTip";
import { AmendmentTag } from "components/Task/AmendmentTag/AmendmentTag";
import { DISPLAY_DATE } from "constants/date";

type AmendmentMarkerProps = {
  amendmentNumber: number;
  startedOn: string | null;
  startedBy: string | null;
};

const AmendmentMarkerTooltip = ({
  amendmentNumber,
  startedOn,
  startedBy,
}: AmendmentMarkerProps) => {
  const startedOnText = startedOn
    ? ` on ${dayjs(startedOn).format(DISPLAY_DATE)}`
    : "";

  return (
    <div className="t-flex t-flex-col t-items-start t-gap-1 t-text-left">
      <span className="t-italic">
        Amendment {amendmentNumber} initiated{startedOnText}
      </span>
      {startedBy && <span className="t-italic">Initiated by {startedBy}</span>}
    </div>
  );
};

export const AmendmentMarker = (props: AmendmentMarkerProps) => (
  <ToolTip text={<AmendmentMarkerTooltip {...props} />}>
    <span>
      <AmendmentTag amendmentNumber={props.amendmentNumber} />
    </span>
  </ToolTip>
);
